const mediaQuery = window.matchMedia("(max-width: 1023px)");

const getContactElements = () => {
  const elements = {
    contact: {
      contactSection: document.querySelector(".contact-content-container"),
      textContainer: document.querySelector(".secondary-text-content"),
      mainTextContainer: document.querySelector(
        ".main-text-content .main-title",
      ),
      secondaryTextContent: document.querySelector(".secondary-text-content"),
    },
  };
  return elements;
};

const validateGsapElements = (elements) => {
  return (
    elements.contact.contactSection &&
    elements.contact.textContainer &&
    elements.contact.mainTextContainer &&
    elements.contact.secondaryTextContent
  );
};

const setGsapElements = (elements) => {
  gsap.set(elements.contact.textContainer, {
    x: mediaQuery.matches ? 600 : 0,
  });
};

const timelineMobile = (container, element, start, end, scrub, duration) => {
  return gsap
    .timeline({
      scrollTrigger: {
        trigger: container,
        start: start,
        end: end,
        scrub: scrub,
        duration,
      },
    })
    .to(element, { x: mediaQuery.matches ? 0 : "" });
};

const timelineDesktop = (
  container,
  start,
  end,
  scrub,
  duration,
  mainTextContainer,
  secondaryTextContent,
) => {
  const isRomanian = document.documentElement.lang
    .toLowerCase()
    .startsWith("ro");
  const allWidth = isRomanian
    ? `${container.offsetWidth - secondaryTextContent.offsetWidth}px`
    : `${mainTextContainer.offsetWidth - secondaryTextContent.offsetWidth}px`;

  return gsap
    .timeline({
      scrollTrigger: {
        trigger: container,
        start: start,
        end: end,
        scrub: scrub,
        duration: duration,
      },
    })
    .to(".main-text-content", {
      minWidth: mediaQuery.matches ? "" : allWidth,
    });
};

const setTimelines = (elements) => {
  timelineMobile(
    elements.contact.contactSection,
    elements.contact.secondaryTextContent,
    "top center",
    "37% center",
    1,
    2,
  );

  timelineDesktop(
    elements.contact.contactSection,
    "top 35%",
    "20% 30%",
    1,
    2,
    elements.contact.mainTextContainer,
    elements.contact.secondaryTextContent,
  );
};

const contactHomeAnim = () => {
  const elements = getContactElements();

  if (!validateGsapElements(elements)) return;
  setGsapElements(elements);
  setTimelines(elements);
};

export default contactHomeAnim;
